import { getIdmeGroupInfo } from './get-id-me-group-info'

export const getPromoCodeInputValue = (couponValue: string): string => {
  const { groupLabel, isIdme } = getIdmeGroupInfo(couponValue)
  return isIdme && groupLabel ? `${groupLabel} Discount Applied` : couponValue
}
